import { render, staticRenderFns } from "./clientProjectReport.vue?vue&type=template&id=8917c170&scoped=true&"
import script from "./clientProjectReport.vue?vue&type=script&lang=js&"
export * from "./clientProjectReport.vue?vue&type=script&lang=js&"
import style0 from "./clientProjectReport.vue?vue&type=style&index=0&id=8917c170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8917c170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8917c170')) {
      api.createRecord('8917c170', component.options)
    } else {
      api.reload('8917c170', component.options)
    }
    module.hot.accept("./clientProjectReport.vue?vue&type=template&id=8917c170&scoped=true&", function () {
      api.rerender('8917c170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/clientProjectReport.vue"
export default component.exports